<template>
  <div>
    <span v-if="podskupine.length==0">{{$t('pages.subgroups.emptySubgroup')}}</span>
    <ul class="list-group">
      <draggable :list="podskupine" @update="posodobi()">
        <li v-for="podskupina in podskupine" :key="podskupina.id" class="list-group-item">
          <div class="row my-margin">
            <div class="pull-left">
              <span>{{ podskupina.name | pickTranslation }}</span>
            </div>
          </div>
        </li>
      </draggable>
    </ul>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import Rest from './../../../services/rest'
  export default {
    name: 'ReorderSubgroups',
    props: {
      podskupine: Array,
      skupinaId: String | Number,
      podskupinaId: String
    },
    data () {
      return {
        omogocenoUrejanje: false
      }
    },
    components: {
      draggable
    },
    created () {

    },
    methods: {
      posodobi () {
        let putData = {
          groupId: this.skupinaId,
          parentId: this.podskupinaId === 'root' ? null : this.podskupinaId,
          subgroupIds: this.podskupine.map(subGroup => subGroup.id)
        }
        return Rest.request('PUT', '/subgroups/reorder/', putData).then((data) => {
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>

<style scoped>
  .tekst {
    color: black;
  }
  .btn-block {
    display:block;
    float:left;
    background-color: #008d4c ;
  }
  .btn-block:hover {
    background-color: #008044 ;
  }
  .btn-block:focus {
    background-color: #008044;
    border-color: #255625;
  }
  .my-margin {
    margin-left: 0.5em;
    margin-right: 0.5em;
  }
  .list-group-item:hover {
    cursor: move;
    background-color: lightgrey;
  }
  .badge {
    cursor: pointer;
  }
  .fa-caret-up {
    color: white
  }
</style>



// WEBPACK FOOTER //
// ReorderSubgroups.vue?4a29a345